import { configureStore } from "@reduxjs/toolkit";

import authSlice from "./authSlice/auth-slice";
import collectionImagesSlice from "./collectionImagesSlice/collection-images-slice";
import singleImageSlice from "./singleImageSlice/single-image-slice";
import imageSearchSlice from "./imageSearchSlice/image-search-slice";
import likedSlice from "./likedSlice/liked-slice";
import collectionsSlice from "./userCollectionsSlice/collections-slice";
import toastSlice from "./ToastSlice/toast-slice";

const store = configureStore({
  reducer: {
    auth: authSlice.reducer,
    collectionImages: collectionImagesSlice.reducer,
    singleImage: singleImageSlice.reducer,
    searchResults: imageSearchSlice.reducer,
    liked: likedSlice.reducer,
    collections: collectionsSlice.reducer,
    toast: toastSlice.reducer,
  },
});

export default store;
